// ----------------------------------------------------------------------
// <copyright file="Izenda.Workspaces.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!(function() {
  var WorkspaceDetail = require('./Izenda.WorkspaceDetail');
  var constants = require('logic/data/Izenda.CopyManagementConstants');
  var m = require('mobx');
  const { map, forEach, concat } = require('lodash/fp');

  function Workspaces() {
    var props = {
      item: new WorkspaceDetail(),
      list: [],
      filter: '',
      tenantList: [],
      showOnlyMyWorkspace: false,
      ownerList: []
    };

    m.extendObservable(this, props);
  }

  /**
   * Set new filter value for connection list.
   * @param {string} newFilter Searching text
   */
  Workspaces.prototype.setFilter = function(newFilter) {
    this.filter = newFilter || '';
  };

  /**
   * Read connection list and map connection data to connection detail instance.
   * That keeps all item in list will be instance of connection detail. It also
   * updates the observable connection list, then the UI will be updated accordingly.
   * @param  {Array} connList Array of connection list that returned from API
   */
  Workspaces.prototype.readWorkspaceList = function(connList) {
    // Populate connection detail item instance from its data
    var createWorkspaceDetail = function(itemData) {
      var item = new WorkspaceDetail();
      item.readDetail(itemData);
      return item;
    };

    // Clean current list and append new connection list
    this.list.splice.apply(this.list, [0, this.list.length].concat(map(createWorkspaceDetail, connList)));
  };

  /**
   * Read tenant list from API, then concat with 'System' object.
   * @param  {Array} tenantList The tenant list that returns from API
   */
  Workspaces.prototype.readTenantList = function(tenantList) {
    this.tenantList = concat(constants.systemSource, tenantList);
    map(function(item) {
      item.tenantName = item.name;
      item.tenantUniqueName = item.tenantID;
      item.name =
        item.id !== constants.systemSource.id ? String.format('{0} - {1}', item.tenantID, item.name) : item.name;
      item.tenantID = item.id;
    }, this.tenantList);
  };

  /**
   * Add new connection and mark it as selected item.
   */
  Workspaces.prototype.addWorkspace = function(id) {
    this.item = new WorkspaceDetail();
    this.item.id = id || null;
    this.item.markDirty();
    this.item.getOriginalTenantList(this.tenantList);
  };

  /**
   * [updateShowWorkspace is to update the status of show only my workspace]
   * @param  {[boolean]} state [description]
   */
  Workspaces.prototype.updateShowWorkspace = function(state) {
    this.showOnlyMyWorkspace = state;
  };

  /**
   * handleShowMyWorkspace is to handle the selected workspace on the middle panel after load list
   */
  Workspaces.prototype.handleShowMyWorkspace = function() {
    var itemExisted = false;
    forEach(
      function(newItem) {
        if (this.item.id === newItem.id) {
          this.item = newItem;
          itemExisted = true;
        }
      }.bind(this),
      this.list
    );

    if (!itemExisted) {
      this.item = this.list[0];
    }
  };

  /**
   * [updateOwnerList description]
   * @param  {[Array]} state [description]
   */
  Workspaces.prototype.updateOwnerList = function(ownerList) {
    this.ownerList = ownerList;
  };

  /**
   * Add a new workspace to list.
   * @param {Object} workspaceDetail Added workspace
   */
  Workspaces.prototype.addWorkspaceToList = m.action(function(workspaceDetail) {
    this.list.push(workspaceDetail);
  });

  module.exports = Workspaces;
})();



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.Workspaces.js